import * as React from "react";
import { Text } from "../../../uikit";
import { Airport } from "@kalabo/golfsavers-common";

interface IProps {
  title: string;
  address: string;
  description: string;
  longitude: number;
  latitude: number;
  onClick?: () => void;
}

const LocationMapAddress = (props: IProps) => {
  return (
    <div className="mb-9 flex flex-col cursor-pointer">
      <Text
        element="h2"
        size={21}
        weight="semibold"
        color="black"
        leading={1.3}
        className="mb-[25px] lg:mb-[30px]"
      >
        {props.title}
      </Text>

      <img
        onClick={() => {
          props.onClick();
        }}
        className="w-full mb-[30px] h-[300px] object-cover rounded-lg border border-bordergrey2"
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${props.latitude},${props.longitude}&zoom=14&scale=2&size=1000x1000&key=AIzaSyDol-lzNJaUNFDgWxBSFyDSiYKeZ9hj8Xk&style=feature:all|element:labels.text|color:0x878787&style=feature:all|element:labels.text.stroke|visibility:off&style=feature:landscape|element:all|color:0xf9f5ed&style=feature:road.highway|element:all|color:0xf5f5f5&style=feature:road.highway|element:geometry.stroke|color:0xc9c9c9&style=feature:water|element:all|color:0xaee0f4&markers=anchor:topleft%7Cscale:1%7Ccolor:0x4CAF50%7C${props.latitude},${props.longitude}`}
      />
      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Address
      </Text>
      <Text size={15} leading={1.5} color="black90">
        {props.address} {props.description && `(${props.description})`}
      </Text>
    </div>
  );
};

export default LocationMapAddress;
